<template>
<div>
  <el-card class="box-card" shadow="hover">
    <div slot="header" class="clearfix" style="position:relative">
      <el-breadcrumb>
        <el-breadcrumb-item>对账</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="text item">
      <el-form ref="form" :model="form" inline label-width="140px">
        <el-form-item label="">
          <el-button size="mini" type="primary" @click="exportStatistics">导出</el-button>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="送货时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="价格">
        <el-input v-model="sreachData.minMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.minMoney" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number> -->
      </el-form-item>
      <span style="line-height:40px;margin:0 10px">-</span>
      <el-form-item label="">
        <el-input v-model="sreachData.maxMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.maxMoney" controls-position="right" :precision="2" :step="0.1" :min="sreachData.minMoney"></el-input-number> -->
      </el-form-item>
      <el-form-item label="数量">
        <el-input-number v-model="sreachData.num" controls-position="right" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="需求来源" v-if="showBtn==3||showBtn<1">
        <el-select v-model="sreachData.company" placeholder="请选择">
          <el-option label="全部" value="-1"></el-option>
          <el-option v-for="(val, key) in company" :key="key" :label="val.company" :value="val.id">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" v-if="showBtn==3||showBtn<1">
        <el-select v-model="sreachData.supplier" filterable clearable placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(val, key) in supplier" :key="key" :label="val.company" :value="val.companyid">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="关键词">
        <el-input v-model="sreachData.words" placeholder="订单号|编码|名称|描述/规格|单位|备注" style="width:300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="searchOrder">查询</el-button>
      </el-form-item>
    </el-form>
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="sn"
          label="订单号">
        </el-table-column>
        <el-table-column
          prop="company"
          label="公司名称">
        </el-table-column>
        <el-table-column
          prop="name"
          label="供应商">
        </el-table-column>
        <el-table-column
          prop="gcode"
          label="物料编号">
        </el-table-column>
        <el-table-column
          prop="title"
          label="物料名称">
        </el-table-column>
        <el-table-column
          prop="num"
          label="送货数量">
        </el-table-column>
        <el-table-column
          prop="price"
          label="含税单价">
        </el-table-column>
        <el-table-column
          prop="total"
          label="含税金额">
        </el-table-column>
        <el-table-column
          prop="send_start_time"
          label="送货日期">
        </el-table-column>
        <el-table-column
          prop="finishTime"
          label="收货">
          <template slot-scope="scope">
            <p v-if="scope.row.finishTime">是</p>
            <p v-else>否</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderRemark"
          label="备注">
        </el-table-column>
      </el-table>
      <p>
      <!-- <span style="float:left">
        <el-button @click="delOrders()">删除所选</el-button>
      </span> -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[5,10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
    </div>
  </el-card>
</div>
</template>
<script>
import userFunction from "@/api/user"
import statisticsFunction from "@/api/statistics"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      tableData:[],
      company:[],
      supplier:[],
      total:0,
      sreachData:{
        page:1,
        limit:10,
        createTime:[],
        num:'',
        supplier:'',
        minMoney:'',
        maxMoney:'',
        company:'',
        status:'',
        words:'',
        vcode:sessionStorage.getItem('token'),
      },
      form:{
        words:'',
        status:"0",
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    handleSizeChange(val){
      this.sreachData.limit = val
      this.list()
    },
    handleCurrentChange(val){
      this.sreachData.page = val
      this.list()
    },
    setWeek(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.sreachData.createTime = [start,end]
    },
    setMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.sreachData.createTime = [start,end]
    },
    setThreeMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.sreachData.createTime = [start,end]
    },
    searchOrder(){
      this.sreachData.page=1
      this.tableData = []
      this.list()
    },
    list(){
      statisticsFunction.list(this.sreachData,this).then((res) => {
        this.tableData = res.data
        this.total = res.total
      })
    },
    getCompany(){
      userFunction.getCompany({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.company = res
      })
    },
    getSupplier(){
      userFunction.getSupplier({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
      })
    },
    exportStatistics(){
      statisticsFunction.exportStatistics(this.sreachData,this).then(res=>{
        let a = document.createElement('a')
        a.href = res.filepath
        a.click()
      })
    },
  },
  mounted () {
    this.list()
    if(this.showBtn<1||this.showBtn==3){
      this.getCompany()
      this.getSupplier()
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/statistics.vue